import { render, staticRenderFns } from "./OutOfLimit.vue?vue&type=template&id=004190a6&scoped=true&"
import script from "./OutOfLimit.vue?vue&type=script&lang=js&"
export * from "./OutOfLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004190a6",
  null
  
)

export default component.exports